import React from 'react';
import { useState, useRef } from 'react';
import PlannerCalendar from './PlannerCalendar/PlannerCalendar';
import PlannerElementMax from './PlannerElements/PlannerElementMax';
import './PlannerPage.css'

//todo migrate handleShopPlan and then sort recipes out
function PlannerPage() {

    const activeRef = useRef(null)

    const [activeDate, setActiveDate] = useState(null)
        
    function handleOutsideClick(e) {
        if (activeRef.current && !activeRef.current.contains(e.target)) {
            setActiveDate(null)
            document.removeEventListener("mousedown", handleOutsideClick);
        }
    }

    return (
        <div className="planner-page-container">
            <div ref={ activeRef } className={activeDate ? "fillable-element visible-element filled" : "fillable-element empty"}>
                {activeDate ? <PlannerElementMax 
                    activeDate={activeDate }
                /> : null}
            </div>
            <PlannerCalendar activeDate={activeDate} setActiveDate={setActiveDate} handleOutsideClick={handleOutsideClick }  />
        </div>
    )
}

export default PlannerPage;